module.exports = __webpack_public_path__ + "static/media/sidebar.5d12d04f.jpg";